import * as React from 'react';
import './css/loading.css';
import {TranslationContext} from './commons';

export const Loading: React.FC = () => {
    return (
        <TranslationContext.Consumer>
            {(tc) => (
                <div className="loading-container">
                    <div className="loading">
                        {tc.translate('Loading') + '…'}
                    </div>
                </div>
            )}
        </TranslationContext.Consumer>
    );
};
